export default {
  order: 8,
  layerGroupId: 'GROUP_LCD',
  dataLayer: {
    id: 'GFW_INTEGRATED_ALERTS',
    order: 8,
    type: 'remoteDataLayer',
    uuid: 'bd58f25d-d3bb-4d59-9daa-cecddd27d9f4',
    groupId: 'GROUP_LCD',
  },
  layer: {
    metadata: {
      metadata: null,
      legendConfig: {
        name: {
          ka: 'ინტეგრირებული ტყის გაჩეხვის გაფრთხილებები',
          zh: '综合毁林警报',
          id: 'Peringatan Deforestasi Terpadu',
          pt: 'Alertas de desflorestação integrados',
          es: 'Alertas de deforestación integradas',
          fr: 'Alertes intégrées sur la déforestation',
          en: 'Integrated deforestation alerts',
        },
        type: 'basic',
        items: [
          {
            outlineColor: '#555555',
            color: '#EDA4C3',
            name: {
              ka: 'Հայտնաբերվել է մեկ ահազանգման համակարգով',
              zh: '由单一警报系统检测到',
              id: 'Terdeteksi oleh satu sistem peringatan',
              pt: 'Detectado por um único sistema de alerta',
              es: 'Detectado por un solo sistema de alerta',
              fr: "Détectée par un seul système d'alerte",
              en: 'Detected by a single alert system',
            },
          },
          {
            outlineColor: '#555555',
            color: '#DC6699',
            name: {
              ka: 'Բարձր վստահություն. հայտնաբերվում է մեկից ավելի անգամ մեկ ահազանգման համակարգի միջոցով',
              zh: '高置信度：由单一警报系统检测到一次以上',
              id: 'Keyakinan tinggi: terdeteksi lebih dari satu kali oleh satu sistem peringatan',
              pt: 'Alta confiança: detectado mais de uma vez por um único sistema de alerta',
              es: 'Alta confianza: Detectado más de una vez por un solo sistema de alerta',
              fr: "Confiance élevée : détectée plus d'une fois par un seul système d'alerte",
              en: 'High confidence: detected more than once by a single alert system',
            },
          },
          {
            outlineColor: '#555555',
            color: '#C92A6D',
            name: {
              ka: 'Ամենաբարձր վստահությունը. հայտնաբերվում է բազմաթիվ ահազանգման համակարգերով',
              zh: '置信度最高：由多个警报系统检测到',
              id: 'Keyakinan tertinggi: terdeteksi oleh beberapa sistem peringatan',
              pt: 'Confiança mais alta: detectado por vários sistemas de alerta',
              es: 'Muy alta confianza: Detectado por múltiples sistemas de alertas',
              fr: "Confiance plus élevée : détectée par plusieurs systèmes d'alerte",
              en: 'Highest confidence: detected by multiple alert systems',
            },
          },
        ],
      },
      interactionConfig: {},
    },
    sublabel: {
      ka: '(ყოველკვირეული, 30მ, აარჩიეთ ქვეყნები, UMD/ GLAD)',
      zh: '（每周，10m，热带地区，UMD/ GLAD）',
      id: '(sehari-hari, 10m, tropis. UMD/GLAD)',
      pt: '(diária, 10m, trópicos, UMD/ GLAD)',
      es: '(diaria, 10m, trópicos, UMD/ GLAD)',
      fr: '(diária, 10m, tropiques, UMD/ GLAD)',
      en: '(daily, 10m, tropics, UMD/GLAD and WUR)',
    },
    label: {
      ka: 'ინტეგრირებული ტყის გაჩეხვის გაფრთხილებები',
      zh: '综合毁林警报',
      id: 'Peringatan Deforestasi Terpadu',
      pt: 'Alertas de desflorestação integrados',
      es: 'Alertas de deforestación integradas',
      fr: 'Alertes intégrées sur la déforestation',
      en: 'Integrated Deforestation Alerts',
    },
    confidence: [0, 1],
    maxDateValue: 999999,
    minDateValue: 15000,
    technicalName: 'gfw_integrated_alerts',
    url: 'https://tiles.globalforestwatch.org/gfw_integrated_alerts/latest/dynamic/{z}/{x}/{y}.png?render_type=encoded&start_date=2021-01-01',
    type: 'integrated-alert-layer',
    id: 'GFW_INTEGRATED_ALERTS',
  },
  isMetadataError: false,
  isError: false,
};
